import { useMemo } from "@wordpress/element";
import {
	formatWeatherStateIcon,
	getStatusTextByWW,
} from "@/helpers/format-weather-state-icon";
import WeatherSumarySkeleton from "../skeletons/weather-summary-skeleton/WeatherSumarySkeleton";
import { useTranslation } from "react-i18next";

import "./style.scss";

type WeatherForecastSummaryProps = {
	searchBar: React.ReactElement;
	weatherInfo?: React.ReactElement;
	weatherData?: {
		ww?: number;
		timestep?: string;
		temperature?: number;
		feelLike?: number;
	};
	isLoading: boolean;
	showFeelLike: boolean;
};

export const WeatherForecastSummary = ({
	searchBar,
	weatherInfo,
	weatherData,
	isLoading,
	showFeelLike,
}: WeatherForecastSummaryProps) => {
	const { t } = useTranslation();

	const { weatherIcon, weatherText } = useMemo(() => {
		let weatherIcon = null;

		if (weatherData?.ww !== undefined && weatherData?.timestep !== undefined) {
			weatherIcon = formatWeatherStateIcon({
				timeStep: weatherData.timestep,
				status: weatherData.ww,
			});
		}

		const weatherText = getStatusTextByWW(weatherData?.ww);

		return {
			weatherIcon,
			weatherText,
		};
	}, [weatherData]);

	return (
		<div className="weather-forecast-summary">
			{searchBar}
			{isLoading && !weatherText && !weatherText ? (
				<WeatherSumarySkeleton />
			) : (
				<div className="visual">
					{weatherIcon ? (
						<img src={weatherIcon} className="icon-visual" alt="weather icon" />
					) : (
						<div className="icon-visual" />
					)}
					<p className="status">{weatherText}</p>
					<div className="temp-div">
						<p className="actual-temp">
							{weatherData?.temperature ?? "-"}
							<span>°C</span>
						</p>
						{showFeelLike && (
							<p className="feel">
								{t("feelLike")} {weatherData?.feelLike ?? "-"}°C
							</p>
						)}
					</div>
				</div>
			)}

			{weatherInfo}
		</div>
	);
};

export default WeatherForecastSummary;
